export default __webpack_public_path__ + "static/media/streak_fire.a92b543c.png";